import { Arc3dRender } from "@visactor/vrender-core/render/symbol";

import { resolveContainerBinding } from "../../../common/explicit-binding";

import { CanvasArc3dPicker, CanvasPickerContribution } from "../constants";

import { DefaultCanvasArc3dPicker } from "./arc3d-picker";

let loadArc3dPick = !1;

export function bindArc3dCanvasPickerContribution(container) {
    var _a;
    loadArc3dPick || (null === (_a = container.isBound) || void 0 === _a ? void 0 : _a.call(container, Arc3dRender)) && (loadArc3dPick = !0, 
    container.bind(CanvasArc3dPicker).toDynamicValue((() => new DefaultCanvasArc3dPicker(resolveContainerBinding(container, Arc3dRender)))).inSingletonScope(), 
    container.bind(CanvasPickerContribution).toService(CanvasArc3dPicker));
}
//# sourceMappingURL=arc3d-module.js.map
